//
// MetadataGroupMenu
//
// Context menu for the metadata inspector groups

import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useStore } from '../stores'
// import { useMousePopover } from '../hooks/useMousePopover'

import { MetadataFieldMenu } from '.'
import { Spacer, VView } from '../appview'
import { Header, Menu, MenuDivider, MenuItem, Property, TextInput } from '../components'
import { validName } from '../utils/text'

const ConfirmSubmenu = observer(function ConfirmSubmenu({ groupname, onAction }) {
    const { app } = useStore()

    const _onAction = action => {
        onAction && onAction(action)
    }

    return (
        <Menu>
            <MenuItem
                className="cc-danger"
                onClick={e => _onAction('delete_metadata_group')}
            >
                {app.text("Yes, delete metadata group '{groupname}'", {
                    groupname,
                })}
            </MenuItem>
        </Menu>
    )
})

export const MetadataGroupMenu = observer(function MetadataGroupMenu({
    item,
    groupname,
    onAction,
}) {
    const { app } = useStore()

    const [newGroupname, setNewGroupname] = useState(groupname)

    if (!groupname || !groupname.length) return

    const _onAction = (action, payload) => {
        onAction &&
            onAction(
                action,
                payload
                    ? payload
                    : {
                          original_groupname: groupname,
                          groupname: newGroupname,
                      }
            )
    }

    const onChangeGroupName = event => {
        setNewGroupname(event.target.value)
    }
    const onBlurGroupName = event => {
        setNewGroupname(event.target.value.trim())
    }

    const save_enabled =
        newGroupname && newGroupname.trim().length && newGroupname !== groupname
    const delete_enabled = !save_enabled
    const add_field_enabled = !save_enabled

    const groupnames = Array.from(item.metadata.keys()).map(key =>
        key.split('.').shift()
    )
    const merge_enabled =
        save_enabled && groupnames.includes(newGroupname) ? true : false

    const save_label = merge_enabled
        ? app.text("Merge with '{name}'", { name: newGroupname })
        : save_enabled
          ? app.text("Rename to '{name}'", { name: newGroupname })
          : app.text('Rename')
    const save_class = merge_enabled ? 'cc-notice' : 'cc-info'

    return (
        <VView
            className="metadatagroupmenu-panel"
            onClick={e => e.nativeEvent.stopImmediatePropagation()}
        >
            <div className="inspector">
                <Header>{app.text('Metadata group')}</Header>
                <Property label={app.text('group name')}>
                    <TextInput
                        onChange={onChangeGroupName}
                        onBlur={onBlurGroupName}
                        value={newGroupname}
                        autoConvert={validName}
                        renderkey={'.groupname'}
                    />
                </Property>
                <Spacer size={5} />
            </div>
            <Menu>
                <MenuItem
                    disabled={!save_enabled}
                    className={save_class}
                    onClick={e => _onAction('save_metadata_group')}
                >
                    {save_label}
                </MenuItem>
                <MenuItem
                    disabled={!delete_enabled}
                    className="cc-danger"
                    submenu={
                        <ConfirmSubmenu groupname={groupname} onAction={_onAction} />
                    }
                >
                    {app.text('Delete')}
                </MenuItem>
                <MenuDivider />
                <MenuItem
                    disabled={!add_field_enabled}
                    submenu={
                        <MetadataFieldMenu
                            item={item}
                            field={undefined}
                            fieldpath={groupname}
                            onAction={_onAction}
                        />
                    }
                >
                    {app.text('Add field')}
                </MenuItem>
                <MenuDivider />
                <MenuItem onClick={e => _onAction('cancel')}>
                    {app.text('Cancel')}
                </MenuItem>
            </Menu>
        </VView>
    )
})
